import { useQueryClient } from '@tanstack/react-query';
import { components, paths } from 'src/generated/v1';
import { $api } from './api';

export type Lot = paths['/products/{product_id}/lots/']['get']['responses']['200']['content']['application/json'][0];
export type LotCreate = components['schemas']['LotCreate'];

export const useLot = (productId: number) => {
  const queryClient = useQueryClient();

  const lotQuery = $api.useQuery('get', '/products/{product_id}/lots/', {
    params: {
      path: {
        product_id: productId,
      },
    },
  });

  const createMutation = $api.useMutation('post', '/products/{product_id}/lots/', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/products/{product_id}/lots/'] });
      queryClient.invalidateQueries({ queryKey: ['get', '/products/{product_id}'] });
    },
  });

  const deleteMutation = $api.useMutation('delete', '/products/lots/{lot_id}', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/products/{product_id}/lots/'] });
      queryClient.invalidateQueries({ queryKey: ['get', '/products/{product_id}'] });
    },
  });

  const updateMutation = $api.useMutation('put', '/products/lots/{lot_id}', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/products/{product_id}/lots/'] });
      queryClient.invalidateQueries({ queryKey: ['get', '/products/{product_id}'] });
    },
  });

  return {
    lots: lotQuery.data,
    createLot: createMutation.mutate,
    createLotAsync: createMutation.mutateAsync,
    deleteLot: deleteMutation.mutate,
    deleteLotAsync: deleteMutation.mutateAsync,
    updateLot: updateMutation.mutate,
    updateLotAsync: updateMutation.mutateAsync,
    isFetching: lotQuery.isLoading,
    isCreating: createMutation.isPending,
    isDeleting: deleteMutation.isPending,
    isUpdating: updateMutation.isPending,
    createError: createMutation.error,
    deleteError: deleteMutation.error,
    updateError: updateMutation.error,
  };
};
